import React from 'react'

export class Pane extends React.Component {
  render() {
    return (
      <div className="tabpane">{this.props.children}</div>
    )
  }
}

class Tabs extends React.Component {
  state = {selected: 0}
  handleClick(e, index) {
    e.preventDefault()
    this.setState({selected: index})
  }

  renderTitle() {
    const Label = (child, index) => {
      let active = (this.state.selected === index) ? 'active' : ''
      return <li className="tabnav-item">
        <a href="javascript:;"
          className={`tabnav-item-link ${active}`}
          onClick={(e) => { this.handleClick(e, index) }}
        >{child.props.label}</a>
      </li>
    }

    return (
      <div className="tabnav">
        <ul>
          {React.Children.map(this.props.children, Label)}
        </ul>
      </div>
    )
  }

  renderContent() {
    return (
      <div className="tabs-content">{this.props.children[this.state.selected]}</div>
    )
  }

  render() {
    return (
      <div className="tabs">
        {this.renderTitle()}
        {this.renderContent()}
      </div>
    )
  }
}

export default Tabs



// WEBPACK FOOTER //
// ./assets/js/lib/Tabs.jsx